import { DisplayPerformanceInnovidScreen } from "types";
import { createScreen } from "utils/createScreen";

const DisplayPerformanceInnovidScreenDefinition = createScreen({
  name: DisplayPerformanceInnovidScreen,
  path: "/dashboard/display-performance-innovid/:innovidCampaignId/:view",
  routePath: [
    "/display-performance-innovid",
    "/display-performance-innovid/:innovidCampaignId",
    "/display-performance-innovid/:innovidCampaignId/:view",
  ],
  accessPath: "campaign.intentAnalysisWithSpotlight",
});

export { DisplayPerformanceInnovidScreenDefinition };
